module.exports = __webpack_public_path__ + "images/icons/icon-15-plus.svg";